import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  block: {
    display: 'block',
  },
})

export default useStyles
